// PopupCard 는 zep-crm admin-web 렌더러를 미러링하는 독립 UI 레이어라
// 도메인 CampaignPosition 에 결합하지 않고 자체 위치 값을 둔다(index.tsx 상단 주석 참고).
// 분기에서 매직스트링을 쓰지 않도록 const + 파생 타입으로 둔다.
export const POPUP_POSITION = {
  BOTTOM_RIGHT: 'BOTTOM_RIGHT',
  CENTER_MODAL: 'CENTER_MODAL',
} as const;

export type PopupPosition =
  (typeof POPUP_POSITION)[keyof typeof POPUP_POSITION];
export type PopupDevice = 'pc' | 'mobile';

export interface PopupCardContent {
  title: string;
  body: string;
  imageUrl?: string;
  dismissText?: string;
  buttons: Array<{ label: string; action?: string; url?: string }>;
}

type PopupButton = PopupCardContent['buttons'][number];
export type IndexedPopupButton = PopupButton & { originalIndex: number };
